/** Resolve root-relative backend URLs when an API base URL is configured. */
export const resolveApiUrl = (url: string): string => {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

  if (!apiBaseUrl || !url.startsWith('/') || url.startsWith('//')) {
    return url;
  }

  return new URL(url, apiBaseUrl).href;
};
